import { render, staticRenderFns } from "./IntroducerPhone.vue?vue&type=template&id=b5f31be0"
import script from "./IntroducerPhone.vue?vue&type=script&lang=js"
export * from "./IntroducerPhone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports